import React from "react";
import { FormattedMessage } from "react-intl";
import StyledLink from "../../../shared/StyledLink/StyledLink";
import "./look.scss";
const Look = () => {
  return (
    <div className="home-look">
      <h1 className="big-title">
        <FormattedMessage
          id="Take"
          defaultMessage="Take a look at 
what we can do"
        />
      </h1>
      <div className="line"></div>
      <StyledLink
        to="/"
        styles="styled"
        linkName={
          <FormattedMessage
            id="ViewPortfolio"
            defaultMessage="View Portfolio"
          />
        }
      />
    </div>
  );
};

export default Look;
